import React, { useEffect, useState, useCallback } from "react";
import { Card, Button } from "react-bootstrap";
import { FlightSearchParams, TransportItem, SearchResponse } from "../../types";
import api from "../../api";
import { apiRoutes } from "../../routes/routes";
import FlightCard from "./FlightCard";
import { formatDate } from "../../functions/Utils";
import LoadingMessage from "../LoadingMessage";
import {
  FaChild,
  FaBaby,
  FaPerson,
  FaPlaneArrival,
  FaPlaneDeparture,
  FaPlane,
} from "react-icons/fa6";
import TransportSearchResults from "../Transports/TransportSearchResults";

interface Props {
  flightParams: FlightSearchParams;
  openSearchResults: (
    type: string,
    response: SearchResponse[],
    params: FlightSearchParams
  ) => void;
}

const getDuration = (duration: number) => {
  return {
    hours: Math.floor(duration / 60),
    minutes: duration % 60,
  };
};

const FlightSearchCard: React.FC<Props> = ({
  flightParams,
  openSearchResults,
}) => {
  const [searchResponse, setSearchResponse] = useState<SearchResponse[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const {
    origin,
    destination,
    departure_date,
    return_date,
    adults = 1,
    children = 0,
    infants = 0,
  } = flightParams;

  // Ex: https://www.kayak.fr/flights/CDG-MAD/2024-07-15/2024-07-22
  const kayakUrl = `https://www.kayak.fr/flights/${origin}-${destination}/${departure_date}${
    return_date ? `/${return_date}` : ""
  }?adults=${adults}&children=${children}&infants=${infants}`;

  const fetchFlights = useCallback(async () => {
    setLoading(true);
    setError(null);
    setSearchResponse([]);
    try {
      const res = await api.get(apiRoutes.search_flights, {
        params: flightParams,
      });


      setSearchResponse(
        [res.data]
      );


    } catch (err) {
      setError("Une erreur est survenue lors de la recherche de vols.");
    } finally {
      setLoading(false);
    }
  }, [flightParams]);

  useEffect(() => {
    fetchFlights();
  }, [fetchFlights]);

  // const displayedFlights = flights.slice(0, 10);

  // if (error) return <div className="card p-3 text-danger">{error}</div>;

  return (
    <Card className="my-4 border-0 bg-light rounded-4">
      <Card.Body>
        <Card.Title className="text-center">
          <FaPlane /> Flights <strong>{origin}</strong> -{" "}
          <strong>{destination}</strong>
        </Card.Title>
        <Card.Text className="m-0 p-0">
          <div className="d-flex justify-content-evenly align-items-center">
            <div className="d-flex justify-content-between align-items-center border-info border-1 text-info rounded-2 p-2">
              <div className="">
                <FaPlaneDeparture className="me-1" />
                <strong>{formatDate(departure_date)}</strong>
              </div>

              {return_date && (
                <div className="ms-3">
                  <FaPlaneArrival className="me-1" />
                  <strong>{formatDate(return_date)}</strong>
                </div>
              )}
            </div>

            <div className="bg-info rounded-2 p-2 text-white d-flex align-items-center">
              <FaPerson size={18} />{" "}
              {adults === null && children === null && infants === null
                ? 1
                : adults === null
                ? 0
                : adults}
              {children > 0 && (
                <>
                  <FaChild size={16} /> {children}
                </>
              )}
              {infants > 0 && (
                <>
                  <FaBaby />
                  {infants}
                </>
              )}
            </div>
          </div>

          <br />
        </Card.Text>

        {loading && <LoadingMessage />}

        {/* {flights && (
          <Card.Text>
            {flights.map((flight) => (
              <FlightCard key={flight.id} flight={flight} />
            ))}
          </Card.Text>
        )} */}
        {!loading && searchResponse && (
          <TransportSearchResults
            responses={searchResponse}
            renderResult={(flight) => <FlightCard flight={flight} />}
            completed={1}
            overview={true}
            results_length={5}
          />
        )}

        {!loading && searchResponse && (
          <div className="d-flex justify-content-center">
            <Button
              variant="primary"
              onClick={() => openSearchResults("flight", searchResponse, flightParams)}
              // target="_blank"
              // rel="noopener noreferrer"
            >
              See more flights
            </Button>
            {/* <Button
              variant="primary"
              href={kayakUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              See more flights
            </Button> */}
            {/* <button
          className="btn btn-sm btn-outline-primary"
          onClick={fetchFlights}
        >
         Rechercher à nouveau
        </button> */}
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default FlightSearchCard;
